/**
 * Feature switches for the parts of the app that run on **upstream
 * Excalidraw's** hosted infrastructure rather than ours:
 *
 * | Feature      | Upstream service                                        |
 * | ------------ | ------------------------------------------------------- |
 * | Collab       | `oss-collab.excalidraw.com` + their Firebase room store  |
 * | Share links  | `json.excalidraw.com` (+ Firebase for the image blobs)   |
 * | AI           | `oss-ai.excalidraw.com`                                  |
 *
 * Chartoon runs on Supabase + Cloudflare and sells this app, so shipping
 * customer traffic to a third party's servers isn't something to do by
 * inheritance. The payloads are end-to-end encrypted, but the dependency and
 * the outage surface are still theirs, so these stay off until each feature
 * has a backend we own.
 *
 * Turning one back on is this file plus a backend — every call site already
 * reads these flags. See `VITE_APP_WS_SERVER_URL` / `VITE_APP_BACKEND_V2_*` /
 * `VITE_APP_AI_BACKEND` in `.env.production` for what each would need to point
 * at instead.
 *
 * Typed as `boolean` rather than inferred literals on purpose: literal `false`
 * narrows every guard to dead code and lint starts complaining.
 */

export const COLLAB_ENABLED: boolean = false;

export const SHARE_LINKS_ENABLED: boolean = false;

export const AI_ENABLED: boolean = false;
